import { makeStyles } from '@material-ui/styles'
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({

    contentDiv: {
      width: "100%"
    },
    testingScopesInput: {
      width: '100%'
    },
    testingScopesSelect: {
      width: '100%',
      position: 'relative',
      borderRadius: '4px',
      border: '1px solid #C4C4C4',
      minHeight: '56px'
    },
    testingScopes: {
      marginTop: '10px',
      width: '100%'
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    error: {
      color: '#f44336 !important',
      borderColor: '#f44336 !important',
    },
}))
